import LinkAPI, { onPostRequest, decodeResponse, onRequestEnterPrise, parseJwt } from './MainController';
import { store } from '../Redux/Store';
import Type from "../Redux/Type";

export function onAuthentication(payload, onSuccess) {

    let onProcessLogin = ({ statusCode, response }) => {
        onProcess({ statusCode, response }, onSuccess);
    };
    onPostRequest(LinkAPI.login, onProcessLogin, payload);
}

export function onChangePassWord(payload, onSuccess) {
    let onProcessChangePassword = ({ statusCode, response }) => {
        onProcess({ statusCode, response }, onSuccess);
    };
    onPostRequest(LinkAPI.changePassWord, onProcessChangePassword, payload);
}

const onProcess = ({ statusCode, response }, onSuccess) => {
    if (statusCode === 200) {
        localStorage.setItem(LinkAPI.token, response)
        let userInfo = decodeResponse(response);
        userInfo = JSON.parse(userInfo);
        // delete userInfo.Password
        store.dispatch({ type: Type.SET_USER_INFO, userInfo });
        store.dispatch({ type: Type.SET_TOKEN, token: response });
        onSuccess({ statusCode, response });
    } else {
        onSuccess({ statusCode, response });
    }
};



export const onCallLoginAPI = (onSearch) => {

};


export const checkExpToken = () => {
    let token = localStorage.getItem(LinkAPI.token)
    if (token) {
        const parseToken = parseJwt(token);
        const exp = parseToken && parseToken.exp ? parseToken.exp : 0;
        let today = (new Date()).getTime().toString();
        today = today.slice(0, 10);
        today = today ? parseInt(today) : today
        if (exp > today) {
            return true
        } else {
            return false
        }
    } else {
        return false
    }
}

